export default __webpack_public_path__ + "static/media/thankyoukeyvis_tickets_tab.f2b8e42a.png";